import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import type { WModuleGroupView } from '@zola/svc-web-api-ts-client';
import * as ActionTypes from '../actions/types/ModuleGroupActionTypes';

export type ModuleGroupsReducerStateType = {
  views: WModuleGroupView[];
  busy: boolean;
};

export const initialState: ModuleGroupsReducerStateType = {
  views: [],
  busy: false,
};

export type ModuleGroupsThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  ModuleGroupsReducerStateType,
  unknown,
  Action<string>
>;
const moduleGroups = (
  state = initialState,
  action: ActionTypes.ModuleGroupActionTypes
): ModuleGroupsReducerStateType => {
  switch (action.type) {
    case ActionTypes.RECEIVE_MODULE_GROUP:
      return {
        ...state,
        views: action.payload.module_group_views,
        busy: false,
      };
    case ActionTypes.REQUEST_MODULE_GROUP:
      return { ...state, busy: true };
    default:
      return state;
  }
};

export default moduleGroups;
